import { HostingModel, ServerModel } from '@/models'
import { ModalView } from '@/abstract'

export class PricingTableModalView extends ModalView<
  HostingModel | ServerModel
> {
  /***
   * @description: NOTE: This method is only implemented for API consistency only. Therefore, It should never be called
   */
  onSubmit(
    model: HostingModel | ServerModel
  ): Promise<HostingModel | ServerModel> {
    throw new Error(
      `Attempt to submit model ${model.id}: Method purposefully not implemented.`
    )
  }
}
